import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RouterSegments } from 'src/app/models/router-segments';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-permission-error',
    templateUrl: './permission-error.component.html',
    styleUrls: ['./permission-error.component.scss'],
    standalone: false
})
export class PermissionErrorComponent {

  tenant: string;
  RouterSegments = RouterSegments;

  constructor(private router: Router, private authService: AuthService,
     private readonly titleService: Title,
    private readonly route: ActivatedRoute) { }

  ngOnInit(): void {
    this.tenant = this.authService.principal.provider;
    this.titleService.setTitle(this.route.snapshot.data.title);
  }

  logout(): void {
    this.authService.logout();
  }
}
